import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import {signUp, getDropdownData, sendOtp, verifyOtp} from '../Services/APIService.js';
import Notification from "./Notification.js";
import '../../Styles/Login.css';
import countryList from 'react-select-country-list';  // This is a helper for getting the country list


export default function Login( {onLogin} ) {
  const [userTypes, setUserTypes] = useState([]);
  const [isLogin, setIsLogin] = useState(true);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [signUpError, setSignUpError] = useState(''); // Separate error state for sign up
  const [loginFormErrors, setLoginFormErrors] = useState({}); // State for login form errors
  const [formErrors, setFormErrors] = useState({}); // State to track individual field errors
  const [loginError, setLoginError] = useState({});
  const [userDetails, setUserDetails] = useState({
    firstName: '',
    lastName: '',
    email: '',
    organization: '',
    country: '',
    address: '',
    userId:'',
  });
  const [otp, setOtp] = useState(new Array(6).fill('')); // Initializing OTP with 6 digits (adjust length as needed)
  const [isOtpSent, setIsOtpSent] = useState(false); // Ensure this line is present


  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const navigate = useNavigate();
  const countries = countryList().getData().map(country => country.label); // Extract country labels

 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getDropdownData();
        setUserTypes(data); // Set the user types in state
      } catch (error) {
        console.error('Failed to fetch user types:', error); // Handle errors
      }
    };

    fetchData();
  }, []);


  const handleNotificationClose = () => {
    setShowNotification(false);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginError('');
    setSignUpError('');

    let hasError = false;

    if (isLogin) {
        // Perform final validation for login
        let loginErrors = { ...loginFormErrors };

        // Email validation
        if (!userDetails.email || !emailPattern.test(userDetails.email)) {
            loginErrors.email = 'Please enter a valid email address.';
            hasError = true;
        }

        setLoginFormErrors(loginErrors);

        if (hasError) {
            setNotificationMessage('Please fix the errors before submitting.');
            setShowNotification(true);
            return;
        }

        try {
            const response = await verifyOtp(userDetails.email, otp);

            if (response?.message === 'OTP verified successfully') {
                onLogin();
            } else {
                setNotificationMessage(response?.message || 'Login failed. Incorrect OTP.');
                setShowNotification(true);
            }
        } catch (err) {
          setNotificationMessage(err?.errorMessage || 'Login failed. Incorrect OTP.');
          setShowNotification(true);
        }
    } else {
        // Final validation for sign-up
        let errors = { ...formErrors };

        // Validate each field
        if (!userDetails.email || !emailPattern.test(userDetails.email)) {
            errors.email = 'Please enter a valid email address.';
            hasError = true;
        }

        // Set the errors if any
        setFormErrors(errors);

        if (hasError) {
            setNotificationMessage('Please fix the errors before submitting.');
            setShowNotification(true);
            return;
        }

        try {
            await signUp(userDetails);
            setUserDetails({
                firstName: '',
                lastName: '',
                email: '',
                organization: '',
                country: '',
                address: '',
                userId: '',
            });
            setNotificationMessage('Sign Up successful!');
            setShowNotification(true);

            setTimeout(() => {
                navigate('/home');
            }, 1000);

        } catch (err) {
            setNotificationMessage(err.message || 'Sign up failed.');
            setShowNotification(true);
        }
    }
};

const handleInputChange = (e) => {
  const { name, value } = e.target;

  // Regular expression to allow only letters and spaces
  const namePattern = /^[A-Za-z\s]*$/;

    if (name === 'firstName' || name === 'lastName') {
      // Only allow valid characters for firstName and lastName
      if (!namePattern.test(value)) {
        return; // Prevent input of numbers or special characters
      }
    }

    setUserDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));

    if (isLogin) {
      // Real-time validation for login form
      let loginErrors = { ...loginFormErrors };
      switch (name) {
        case 'email':
          loginErrors.email = emailPattern.test(value) ? '' : 'Please enter a valid email address.';
          break;

        default:
          break;
      }
      setLoginFormErrors(loginErrors);

    } else {
      // Real-time validation for sign-up form
      let errors = { ...formErrors };
      switch (name) {
        case 'email':
          errors.email = emailPattern.test(value) ? '' : 'Please enter a valid email address.';
          break;
          
    default:
    break;
    }
    setFormErrors(errors);
  } 
};

  const toggleAuthMode = () => {
    setIsLogin((prevMode) => !prevMode);
    setUserDetails({ email: '', password: '' });
  };

  const sendOtpHandler = async (e) => {
    try {
      // Check if email is entered
      if (!userDetails.email) {
        setNotificationMessage('Please enter your email address.');
        setShowNotification(true);
        return;
      }
  
      // Send OTP
      const response = await sendOtp(userDetails.email);
      // Check if the response contains an error message
      if (response.status === 401) {
        setIsOtpSent(false);
        setNotificationMessage("User is Unauthorized");  // Display the error message
        setShowNotification(true);
        return;
      }
      
      if (response.message) {
        setIsOtpSent(true);
        setNotificationMessage('OTP Sent to your Email!');
        setShowNotification(true);
      } else  {
        setIsOtpSent(false);
        setNotificationMessage("Email ID Not Found.Please Register.");
        setShowNotification(true);
      }

    } catch (err) {
      setIsOtpSent(false);
      setNotificationMessage('An Error Occurred while Sending OTP.');
      setShowNotification(true);
    }
  };
  



 // Handle OTP input change
 const handleOtpChange = (element, index) => {

  if (isNaN(element.value)) return;

  const newOtp = [...otp];
  newOtp[index] = element.value;
  setOtp(newOtp);

  // Move to the next input box if the current box is filled
  if (element.nextSibling && element.value) {
    element.nextSibling.focus();
  }
};


  return (
    <div className="auth-page">
      <div className="header">
        <div className="logo-container">
          <h1><span className="stylish-2">LZAY </span> Quote</h1>
        </div>
      </div>
      <div className="auth-container">
        <h2>{isLogin ? 'Login' : 'Sign Up'}</h2>
        <form onSubmit={handleSubmit}>
          {isLogin ? (
            <>
              <div className="login-input-group" >
                <label htmlFor="email">Email <span style={{ color: 'red', fontSize: '12px' }}>*</span> </label>
                <div className="password-container">
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={userDetails.email}
                  onChange={handleInputChange}
                  placeholder="Enter your email"
                  autoComplete="off"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault(); // Prevents form submission
                      sendOtpHandler();   // Programmatically triggers the OTP button click
                    }
                  }}
                  required
                />
                </div>
                {loginFormErrors.email && <ErrorPopup message={loginFormErrors.email} />}
              </div>

              {/* OTP Button */}
              <div className="otp-button-container">
                <button
                  type="button"
                  className="otp-btn"
                  onClick={sendOtpHandler}
                  disabled={isOtpSent} // Disable if OTP is already sent
                >
                  {isOtpSent ? 'OTP Sent' : 'Send OTP'}
                </button>
              </div>

              {isOtpSent && (
              <div style={{ marginTop: '20px', display: 'flex', gap: '5px' }}>
              {otp.map((digit, index) => (
                <input
                  className="otp-input-box"
                  key={index}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleOtpChange(e.target, index)}
                  onFocus={(e) => e.target.select()}
                  style={{
                    padding: '4px',
                    width: '21px',
                    textAlign: 'center',
                    fontSize: '15px',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                  }}
                />
              ))}
            </div>
          )} 
          </>

          ) : (

            <div className="input-container">
              <div className="input-group">
              <label htmlFor="firstName">First Name  <span style={{ color: 'red', fontSize: '12px' }}>*</span> </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={userDetails.firstName}
                  onChange={handleInputChange}
                  placeholder="Enter your first name"
                  required
                />
                 {formErrors.firstName && <p className="error-message">{formErrors.firstName}</p>}
              </div>

              <div className="input-group">
              <label htmlFor="lastName">Last Name</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={userDetails.lastName}
                  onChange={handleInputChange}
                  placeholder="Enter your last name"
                />
                {formErrors.lastName && <p className="error-message">{formErrors.lastName}</p>}
              </div>

              <div className="input-group">
              <label htmlFor="email">Email  <span style={{ color: 'red', fontSize: '12px' }}>*</span> </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={userDetails.email}
                  onChange={handleInputChange}
                  placeholder="Enter your email"
                  required
                />
                 {formErrors.email && <ErrorPopup message={formErrors.email} />} 
              </div>

              <div className="input-group">
              <label htmlFor="organization">Organization</label>
                <input
                  type="text"
                  id="organization"
                  name="organization"
                  value={userDetails.organization}
                  onChange={handleInputChange}
                  placeholder="Enter your organization"  
                />
              </div>

              <div className="input-group">
              <label htmlFor="country">Country  <span style={{ color: 'red', fontSize: '12px' }}>*</span> </label>
                <select
                  className='country'
                  id="country"
                  name="country"
                  value={userDetails.country}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select your country</option>
                  {countries.map((country) => (
                    <option key={country} value={country}>
                      {country}
                    </option>
                  ))}
                </select>
              </div>

              <div className="input-group">
              <label htmlFor="address"> Address <span style={{ color: 'red', fontSize: '12px' }}>*</span> </label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={userDetails.address}
                  onChange={handleInputChange}
                  placeholder="Enter your address"
                  required
                />
              </div>

              <div className="input-group">
              <label htmlFor="user">User Type  <span style={{ color: 'red', fontSize: '12px' }}>*</span> </label>
                <select
                  className='user'
                  id="user"
                  name="user"
                  value={userDetails.user}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select user type</option>
                  {userTypes.map((user) => (
                    <option key={user.userId} value={user.userId}>
                      {user.userName}
                    </option>
                  ))}
                </select> 
              </div>
              
              <div className='error-container'>
                {signUpError && <p className="error-message">{signUpError}</p>}
              </div>
            </div>
          )}
          <button className="auth-button" type="submit" >
            {isLogin ? 'Login' : 'Sign Up'}
          </button>
        </form>
        <p className="switch-mode">
          {isLogin ? "Don't have an account? " : "Already have an account? "}
          <a href="#" onClick={toggleAuthMode}>
            {isLogin ? 'Sign Up' : 'Login'}
          </a>
        </p>
      </div>

      <Notification 
        message={notificationMessage} 
        show={showNotification} 
        onClose={handleNotificationClose} 
      />
    </div>
  );
}

function ErrorPopup({ message }) {
  return (
    <div className="error-popup">
      <div className="error-popup-arrow"></div>
      <p><span className="yellow-box">!</span>{message}</p>
    </div>
  ); 
}